import { render, staticRenderFns } from "./OsExternaArmazem.vue?vue&type=template&id=dc524244&"
import script from "./OsExternaArmazem.vue?vue&type=script&lang=js&"
export * from "./OsExternaArmazem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports